import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntitySettingsLayoutComponent } from './entity-settings-layout.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SettingsTabLabelModule } from '@fleet/ui';

@NgModule({
  declarations: [EntitySettingsLayoutComponent],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatIconModule,
    RouterModule,
    SettingsTabLabelModule,
  ],
  exports: [EntitySettingsLayoutComponent],
})
export class EntitySettingsLayoutModule {}
